import * as React from "react";
import { List, Datagrid, TextField, NumberField, BooleanField, FunctionField } from "react-admin";
import { FrDateField } from "../../components/FrDateField";
import { PersonChip } from "../../components/ui";

// Réductions / bonus accordés (GET /admin/discount-bonus).
export default {
  list: () => (
    <List sort={{ field: "createdAt", order: "DESC" }} perPage={50} title="Réductions & bonus">
      <Datagrid rowClick={false} bulkActionButtons={false}>
        <FunctionField label="Utilisateur" render={(r) => <PersonChip id={r?.userId} name={r?.user} resource="users" dense />} />
        <NumberField locales="fr-FR" source="amount" label="Montant (€)" options={{ style: "currency", currency: "EUR" }} />
        <BooleanField source="used" label="Utilisé" />
        <TextField source="reason" label="Raison" />
        <FrDateField source="createdAt" label="Date" showTime />
      </Datagrid>
    </List>
  ),
};
